import { ReactElement } from 'react';
import { useState } from 'react'

import {
  BrowserRouter as Router,
  Route,
  Link,
  Routes
} from "react-router-dom";

import styled from 'styled-components';
import { WalletStatus } from './components/WalletStatus';
import { ActivateDeactivate } from './components/ActivateDeactivate';
import { SectionDivider } from './components/SectionDivider';
import './App.css';

//Contracts
import { ERC20GameTokenApp } from './components/ERC20GameTokenApp';
import { BUSDTokenApp } from './components/BUSDTokenApp';
import { SAFUUTokenApp } from './components/SAFUUTokenApp';
import { ERC721GameNFTApp } from './components/ERC721GameNFTApp';
//import { ERC721GameOGNFTApp } from './components/ERC721GameOGNFTApp';
import { LeaderboardApp } from './components/LeaderboardApp';
import { HomePageApp } from './components/HomePageApp';
import { OGHoldingPageApp } from './components/OGHoldingPageApp';
import { BitcoreApp } from './components/BitcoreApp';

import { PlateFuseApp } from './components/PlateFuseApp';
import { PlatecoreApp } from './components/PlatecoreApp';

import { StackFuseApp } from './components/StackFuseApp';
import { StackcoreApp } from './components/StackcoreApp';

import { DualStackFuseApp } from './components/DualStackFuseApp';
import { DualStackcoreApp } from './components/DualStackcoreApp';

import { PlanetOwnerApp } from './components/PlanetOwnerApp';
import { PlanetOwnerLiteApp } from './components/PlanetOwnerLiteApp';

import { NodeOwnerApp } from './components/NodeOwnerApp';
import { LiteNodeOwnerApp } from './components/LiteNodeOwnerApp';

import { ERC20GameTokenSwapApp } from './components/ERC20GameTokenSwapApp';

import { ERC20CosmicCoinV1App } from './components/ERC20CosmicCoinV1App';
import { CosmicCoinSwapApp } from './components/CosmicCoinSwapApp';

import { MegaMiningClaimApp } from './components/MegaMiningClaimApp';
import { RegularMiningClaimApp } from './components/RegularMiningClaimApp';

import { ERC20CosmicForcePaydirtTokenApp } from './components/ERC20CosmicForcePaydirtTokenApp';

import { PaydirtNFTApp } from './components/PaydirtNFTApp';
import { PaydirtNFTSellApp } from './components/PaydirtNFTSellApp';



//ADMIN APPS
import { ERC20GameTokenADMINApp } from './components/ERC20GameTokenADMINApp';
import { ERC721GameNFTADMINApp } from './components/ERC721GameNFTADMINApp';
import { OGADMINPApp } from './components/OGAMINApp';

const StyledAppDiv = styled.div`
  display: grid;
  grid-gap: 20px;
`;

export function App(): ReactElement {

  const [nft, setNFT] = useState({})
  const [marketplace, setMarketplace] = useState({})
  

  // 0 = LIVE
  // 1 = HOMPAGE ONLY
  // 2 = ADMIN
  // 3 = DEV
  const LIVE = Number(0);
  const HOMPAGE = Number(1);
  const ADMIN = Number(2);
  const DEV = Number(3);

  //SET HERE
  const SELECTOR = LIVE;

  if (SELECTOR == LIVE) {   //LIVE
    return (
      <StyledAppDiv>
          <Router>

            <div>
              <ul>
                <li>
                  <a href="https://www.cosmicforce.xyz" target="_self" rel="home">
                  Home
                  </a>
                </li>
                <li>
                  <a href="https://marketplace.cosmicforce.xyz" target="_self" rel="home">
                  Marketplace
                  </a>
                </li>
                <li>
                  <Link to="/cosmic">COSMIC COIN</Link>
                </li>
                <li>
                  <Link to="/cosmicswap">COSMIC SWAP</Link>
                </li>
                <li>
                  <Link to="/cfxtoken">CFX TOKEN</Link>
                </li>
                <li>
                  <Link to="/cfxswap">CFX SWAP</Link>
                </li>
                <li>
                  <Link to="/cfptoken">CFP TOKEN</Link>
                </li>
                <li>
                  <Link to="/alphatoken">ALPHA</Link>
                </li>
                <li>
                  <Link to="/ogtoken">OG</Link>
                </li>
                <li>
                  <Link to="/bitcore">BITCORE</Link>
                </li>
                <li>
                  <Link to="/platecore">PLATECORE</Link>
                </li>
                <li>
                  <Link to="/stackcore">STACKCORE</Link>
                </li>
                <li>
                  <Link to="/dualstackcore">DUALSTACKCORE</Link>
                </li>
                <li>
                  <Link to="/planetowner">PLANET 1%</Link>
                </li>
                <li>
                  <Link to="/planetownerlite">PLANET 0.1%</Link>
                </li>
                <li>
                  <Link to="/nodeowner">COSMIC NODE</Link>
                </li>
                <li>
                  <Link to="/litenodeowner">COSMIC LITE NODE</Link>
                </li>
                <li>
                  <Link to="/megamineowner">MEGA CLAIM</Link>
                </li>
                <li>
                  <Link to="/mineowner">REGULAR CLAIM</Link>
                </li>
                <li>
                  <Link to="/paydirtnft">PAYDIRT NFT</Link>
                </li>
            <li>
            <a href="https://whitepaper.cosmicforce.xyz/" target="_blank" rel="cosmicpdf">
                WhitePaper
              </a>
            </li>
            <li>
            <a href="https://medium.com/cosmic-force" target="_blank" rel="cosmic_help">
                Help & Info
              </a>
            </li>
              </ul>
            </div>
          <ActivateDeactivate />
    
            <div>
              <Routes>
                <Route path="/" element={<ERC20CosmicCoinV1App />}></Route> 
                <Route path="/cosmic" element={<ERC20CosmicCoinV1App />}></Route>  
                <Route path="/cosmicswap" element={<CosmicCoinSwapApp />}></Route>  
                <Route path="/cfxtoken" element={<ERC20GameTokenApp />}></Route>  
                <Route path="/cfxswap" element={<ERC20GameTokenSwapApp />}></Route> 
                <Route path="/cfptoken" element={<ERC20CosmicForcePaydirtTokenApp />}></Route>
                <Route path="/alphatoken" element={<ERC721GameNFTApp />}></Route> 
                <Route path="/ogtoken" element={<OGHoldingPageApp />}></Route> 
                <Route path="/bitcore" element={<BitcoreApp />}></Route> 
                <Route path="/platecore" element={<PlatecoreApp />}></Route> 
                <Route path="/stackcore" element={<StackcoreApp />}></Route> 
                <Route path="/dualstackcore" element={<DualStackcoreApp />}></Route>
                <Route path="/platefuse" element={<PlateFuseApp />}></Route>  
                <Route path="/stackfuse" element={<StackFuseApp />}></Route>  
                <Route path="/dualstackfuse" element={<DualStackFuseApp />}></Route>  
                <Route path="/planetowner" element={<PlanetOwnerApp />}></Route>
                <Route path="/planetownerlite" element={<PlanetOwnerLiteApp />}></Route>
                <Route path="/nodeowner" element={<NodeOwnerApp />}></Route>
                <Route path="/litenodeowner" element={<LiteNodeOwnerApp />}></Route>
                <Route path="/megamineowner" element={<MegaMiningClaimApp />}></Route>
                <Route path="/mineowner" element={<RegularMiningClaimApp />}></Route>   
                <Route path="/paydirtnft" element={<PaydirtNFTApp />}></Route>   
                <Route path="/showpaydirtnft" element={<PaydirtNFTSellApp />}></Route>  
              </Routes>
            </div>
          </Router>
        </StyledAppDiv>
      );

} else if (SELECTOR == ADMIN) {   //ADMIN
  return (
  <StyledAppDiv>
      <Router>
        <div>
          <ul>
           <li>
              <a href="https://www.cosmicforce.xyz/" target="_self" rel="home">
              Home
              </a>
            </li>
            <li>
              <Link to="/cfxtoken">CFX Token</Link>
            </li>
            <li>
              <Link to="/alphatoken">ALPHA NFT</Link>
            </li>
            <li>
                <Link to="/ogtoken">OG NFT</Link>
            </li>
            <li>
              <Link to="/cfxadmin">ADMIN CFX</Link>
            </li>
            <li>
              <Link to="/alphaadmin">ADMIN ALPHA</Link>
            </li>
            <li>
              <Link to="/ogaadmin">OG ALPHA</Link>
            </li>
          </ul>
        </div>
      <ActivateDeactivate />

        <div>
          <Routes> 
            <Route path="/" element={<HomePageApp />}></Route> 
            <Route path="/cfxtoken" element={<ERC20GameTokenApp />}></Route>  
            <Route path="/alphatoken" element={<ERC721GameNFTApp />}></Route> 
            <Route path="/ogtoken" element={<OGHoldingPageApp />}></Route> 
            <Route path="/cfxadmin" element={<ERC20GameTokenADMINApp />}></Route>  
            <Route path="/alphaadmin" element={<ERC721GameNFTADMINApp />}></Route>   
            <Route path="/ogaadmin" element={<OGADMINPApp />}></Route>  
          </Routes>
        </div>
      </Router>
    </StyledAppDiv>
  );
  } else if (SELECTOR == HOMPAGE) { //Home Page Only
    return (
      <StyledAppDiv>
          <Router>

            <div>
              <ul>
              <li>
                <a href="https://www.cosmicforce.xyz/" target="_self" rel="home">
                Home
                </a>
              </li>
              </ul>
            </div>
          <ActivateDeactivate />
    
            <div>
              <Routes>  
                <Route path="/" element={<HomePageApp />}></Route>              
              </Routes>
            </div>
          </Router>
        </StyledAppDiv>
      );
      } else if (SELECTOR == LIVE) {   //Live
        return (
          <StyledAppDiv>
              <Router>
    
                <div>
                  <ul>
                    <li>
                    <a href="https://www.cosmicforce.xyz/" target="_self" rel="home">
                    Home
                    </a>
                    </li>
                    <li>
                      <Link to="/cfxtoken">CFX Token</Link>
                    </li>
                    <li>
                      <Link to="/alphatoken">ALPHA NFT</Link>
                    </li>
                    <li>
                      <Link to="/ogtoken">OG NFT</Link>
                    </li>
                <li>
                <a href="./images/Cosmic_Force_LitePaper.pdf" target="_blank" rel="cosmicpdf">
                    Litepaper
                  </a>
                </li>
                <li>
                <a href="https://medium.com/cosmic-force/cosmic-force-help-af50e4eea1" target="_blank" rel="cosmic_help">
                    Help
                  </a>
                </li>

                

                  </ul>
                </div>
              <ActivateDeactivate />
        
                <div>
                  <Routes>
                    <Route path="/" element={<HomePageApp />}></Route> 
                    <Route path="/cfxtoken" element={<ERC20GameTokenApp />}></Route>  
                    <Route path="/alphatoken" element={<ERC721GameNFTApp />}></Route> 
                    <Route path="/ogtoken" element={<OGHoldingPageApp />}></Route> 
                  </Routes>
                </div>
              </Router>
            </StyledAppDiv>
          );

  } else if (SELECTOR == DEV) {   //Live
    return (
      <StyledAppDiv>
          <Router>

            <div>
              <ul>
                <li>
                  <a href="https://www.cosmicforce.xyz/" target="_self" rel="home">
                  Home
                  </a>
                </li>
                <li>
                  <Link to="/cfxtoken">CFX Token</Link>
                </li>
                <li>
                  <Link to="/cfxswap">CFX SWAP</Link>
                </li>
                <li>
                  <Link to="/alphatoken">ALPHA NFT</Link>
                </li>
                <li>
                  <Link to="/ogtoken">OG NFT</Link>
                </li>
                <li>
                  <Link to="/bitcore">BITCORE NFT</Link>
                </li>
                <li>
                  <Link to="/platecore">PLATECORE NFT</Link>
                </li>
                <li>
                  <Link to="/stackcore">STACKCORE NFT</Link>
                </li>
                <li>
                  <Link to="/dualstackcore">DUALSTACKCORE NFT</Link>
                </li>
                <li>
                  <Link to="/planetowner">PLANET 1% NFT</Link>
                </li>
                <li>
                  <Link to="/planetownerlite">PLANET 0.1% NFT</Link>
                </li>
                <li>
                  <Link to="/nodeowner">COSMIC NODE NFT</Link>
                </li>
                <li>
                  <Link to="/litenodeowner">COSMIC LITE NODE NFT</Link>
                </li>
            <li>
            <a href="https://whitepaper.cosmicforce.xyz/" target="_blank" rel="cosmicpdf">
                WhitePaper
              </a>
            </li>
            <li>
            <a href="https://medium.com/cosmic-force" target="_blank" rel="cosmic_help">
                Help & Info
              </a>
            </li>
              </ul>
            </div>
          <ActivateDeactivate />
    
            <div>
              <Routes>
                <Route path="/" element={<HomePageApp />}></Route> 
                <Route path="/cfxtoken" element={<ERC20GameTokenApp />}></Route>  
                <Route path="/cfxswap" element={<ERC20GameTokenSwapApp />}></Route>  
                <Route path="/alphatoken" element={<ERC721GameNFTApp />}></Route> 
                <Route path="/ogtoken" element={<OGHoldingPageApp />}></Route> 
                <Route path="/bitcore" element={<BitcoreApp />}></Route> 
                <Route path="/platecore" element={<PlatecoreApp />}></Route> 
                <Route path="/stackcore" element={<StackcoreApp />}></Route> 
                <Route path="/dualstackcore" element={<DualStackcoreApp />}></Route>
                <Route path="/platefuse" element={<PlateFuseApp />}></Route>  
                <Route path="/stackfuse" element={<StackFuseApp />}></Route>  
                <Route path="/dualstackfuse" element={<DualStackFuseApp />}></Route>  
                <Route path="/planetowner" element={<PlanetOwnerApp />}></Route>
                <Route path="/planetownerlite" element={<PlanetOwnerLiteApp />}></Route>
                <Route path="/nodeowner" element={<NodeOwnerApp />}></Route>
                <Route path="/litenodeowner" element={<LiteNodeOwnerApp />}></Route>     
              </Routes>
            </div>
          </Router>
        </StyledAppDiv>
      );

} else {   //Default Home Page Only
    return (
      <StyledAppDiv>
          <Router>

            <div>
              <ul>
              <li>
                <a href="https://www.cosmicforce.xyz/" target="_self" rel="home">
                Home
                </a>
              </li>
              </ul>
            </div>
          <ActivateDeactivate />
    
            <div>
              <Routes> 
                <Route path="/" element={<HomePageApp />}></Route>               
              </Routes>
            </div>
          </Router>
        </StyledAppDiv>
    );
  }

} 
